<template>
  <div  v-if="show_body">
    <!-- 测评答题 -->
    <answer-questions  :array="data.list" :interruptShow="interruptShow" :data_="data"  @interruptHandle="interruptHandle" :intro="data.intro?data.intro.split('\r'):[]" @saveReportHandle="saveReportHandle"></answer-questions>

    <!-- 判断链接是否失效 -->
    <van-popup class="pub_alert" v-model="failureShow" :close-on-click-overlay="false">
        <div class="confirm_box">
          <h2 class="on">{{failureMsg}}</h2>
        </div>
    </van-popup>
    <!-- 关注二维码 -->
    <van-popup class="radius" :close-on-click-overlay="false" v-model="isShow">
        <img v-if="is_main" class="qr-box" src="@a/career_ceping47.jpg" />
        <img v-else class="qr-box" src="@a/coach_ceping47.jpg" />
    </van-popup>
    <!-- 关卡介绍 -->
    <public-level :level_list_id="level_list_id" :cpBool="true"></public-level>
    <!-- 填写个人资料 -->
    <learning-profile-confirmation :cid="data.cid" :query="$route.query" :extraObj="extraObj"
      :initialValue="extra" :submitting="submitting" v-if="userInfoBool" @saveuserinfo="saveUserInfo" />
  </div>
</template>
<script>
import { ceping113_index,ceping113_answer,get_extra_info,ceping_event} from '@/api/measurement'
import { deleteStorage,isMain} from '@/utils/tools'
import { learningProfileFields, copyLearningProfile, hasLearningProfile } from '@/utils/learning-assessment-profile'
import { shareCon} from "@/utils/wxconfig";
import AnswerQuestions from "@c/measurement/answer-questions-ul";
import LearningProfileConfirmation from "@c/measurement/learning-profile-confirmation";

import PublicLevel from '@c/course/public-level'
export default {
  data() {
      return {
        show_body: false,
        list: [],
        data: {},
        // 上一页面路由
        formPath: '',
        failureShow:false,
        interruptShow:false,
        failureMsg:'',
        // 关卡
        level_list_id:'',
        isShow:false,
        type_obj: {
            evaluation_id: "",
            evaluation_name: "",
            // evaluation_id: ""
        },
        // 存储答题数据
        extra:{},
        extraObj:{},
        userInfoBool:false,
        loadingProfile:false,
        submitting:false,
        subscribe:false,
        queArr:[]
      }
    },
    components:{
      AnswerQuestions,
      PublicLevel,
      LearningProfileConfirmation,
    },
    computed: {
      is_not_buy() {
        return !this.data.is_buy;
      },
      // 是否购买课程
      is_buy(){
        return (!this.data.is_buy && !this.data.msg)
      },
      is_main(){
        return isMain()
      },
      // 文字换行
      textToHtml(){
        return function(text){
          let arr = text.split('')
          arr =  arr.map((v,index)=>{
           // return index==3?v+'<br/>':
            return ((index==arr.length-1)?v+'：':v)
          });
          return arr.join('');
        }
      }
    },
    methods: {
      interruptHandle(bool){
        this.interruptShow = bool;
      },
      // 只有本次资料确认后才提交答案，失败时保留资料和答案。
      saveUserInfo(extra) {
        if (this.submitting) return;
        this.extra = copyLearningProfile(this.extraObj, extra || this.extra);
        if (!hasLearningProfile(this.extraObj, this.extra)) {
          this.$toast('请完善身份信息');
          return;
        }
        const obj = { ...this.extra, answer: JSON.stringify(this.queArr) };
        if (this.$route.query.sid) obj.sid = this.$route.query.sid;
        this.submitting = true;
        this.$toast.loading({ mask: true, message: '提交中...' });
        return ceping113_answer(obj).then(data => {
          if (!data || data.code == 10002 || data.error > 0 || !data.evaluation_id) {
            throw new Error((data && data.msg) || '提交失败，请重试');
          }
          deleteStorage(this.$route.path);
          this.userInfoBool = false;
          this.$toast.clear();
          this.$toast('提交成功！');
          if (this.data.need_subscribe && !this.data.subscribe) {
            this.isShow = true;
          } else {
            this.$router.push({
              path: '/ceping113_report',
              query: { ...this.$route.query, uid: data.uid, evaluation_id: data.evaluation_id }
            });
          }
        }).catch(error => {
          this.$toast.clear();
          this.$toast(error.message || '提交失败，请重试');
        }).then(() => {
          this.submitting = false;
        });
      },
      // 每次答题完成均进入确认或填写，不再按已有资料自动提交。
      saveReportHandle(arr) {
        if (!Array.isArray(arr) || !arr.length || this.loadingProfile || this.userInfoBool || this.submitting) return;
        this.queArr = arr;
        this.loadingProfile = true;
        return get_extra_info().then(data => {
          this.extra = copyLearningProfile(this.extraObj, (data && data.extra) || this.extra);
        }).catch(() => {
          this.extra = copyLearningProfile(this.extraObj, this.extra);
        }).then(() => {
          this.loadingProfile = false;
          this.userInfoBool = true;
        });
      },
      pullData() {
        //调用加载中
        this.$emit('loadingHandle',true,"拼命加载中...");
        let q = this.$route.query;
        // 获取关卡信息
        this.level_list_id = q.level_list_id?q.level_list_id:'';
        let obj = {
          state: this.$route.query.state,
        };
        if(this.$route.query.code){
          obj['code'] = this.$route.query.code;
        }
        ceping113_index(obj)
          .then((data) => {

            // data.code = 10001;//可以重复测评
            // deleteStorage(this.$route.path);

            if (data.code == 10002) {
              if (this.formPath === '/ceping113_report') {
                this.$router.back();
              } else {
                // 已经测评完成
                this.$router.push({
                  path:'/ceping113_report',
                  query:this.$route.query
                });
              }

            } else {
              this.data = data;
              document.title = data.headtitle;
              this.extraObj = learningProfileFields(data.extra);
              //判断是否是已购买课程并且链接已使用或者失效
              if(data.msg){
                this.failureMsg = data.msg;
                this.failureShow = true;
              }else{
                //判断是否是已购买课程并且有本地缓存
                if(data.is_buy && window.localStorage.getItem(this.$route.path)){
                  this.interruptShow = true;
                }
              }
              this.show_body = true;

              ceping_event({ lead_sid: this.$route.query.lead_sid,
                cid: data.cid,
                event: 'ViewIndex',
              }).then(res=>{
                // 页面访问统计
              });

              // 神策统计--打开页面时触发
              // sensors.track('evaluationPage', {
              //   evaluation_id: data.cid,
              //   evaluation_name: data.headtitle,
              //   evaluation_url: window.location.href,
              //   evaluation_page_title: data.headtitle,
              //   share_user_id: this.$route.query.share_uid ? this.$route.query.share_uid : "",
              //   channel_name: this.$route.query.channel ? this.$route.query.channel : ""
              // })
              // 给wxconfig传对象
              this.type_obj.nickname = data.nickname;
              this.type_obj.evaluation_id = data.cid+'';
              this.type_obj.evaluation_name = data.headtitle;
              this.type_obj.evaluation_user_id = String(data.uid);
              this.type_obj.path = this.$route.path;

              shareCon("ceping113", this, this.type_obj);
            }
            //关闭加载中
            this.$emit('loadingHandle',false);


          })
      },
    },
    /*
     *@param: 
     *@return: 
     *@Description: 获取上一个页面的路由
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-11-01 15:27:53
    */
    beforeRouteEnter(to, from, next) {
      next(vm => { //  这里的vm指的就是vue实例，可以用来当做this使用
        vm.formPath = from.path;
      })
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>


.confirm_box {
  h2 {
    padding-bottom: 12px;
    padding: 40px 30px;
  }
  p {
    margin-bottom: 50px;
    font-size: 26px;
    color: #666;
  }
  .btn_group {
    .confirm {
      width: 100%;
    }
  }
}
.radius {
  border-radius: 10px;
}
.qr-box{
    width:600px;
}
.save-userinfo{
  position: fixed;
  width: 100%;
  max-width: 750px;
  left: -100%;
  transform: translateX(-50%);
  top: 0;
  height: 100%;
  background-color: #ffffff;
  padding: 150px 60px 100px;
  overflow: auto;
  .u-title{
    font-size: 36px;
    color: #333;
    text-align: center;
    margin-bottom: 80px;
    font-weight: bold;
  }
  .u-input{
    display: flex;
    align-items: center;
    font-size: 30px;
    margin-bottom: 50px;
    label{
      display: block;
      width: 150px;
      text-align: right;
    }
    input{
      line-height: 70px;
      flex: 1;
      border:2px solid #F57F17;
      border-radius: 15px;
      padding-left: 10px;
      font-size: 26px;
      background-color: #ffffff;
    }
    .interest-label{
      width: 600px;
    }
    .interest-label.on{
      width: 150px;
      text-align: right;
    }
  }
  .u-input.on{
    flex-direction: column;
    label{
      display: block;
      margin-right: auto;
      text-align: left;
    }
    .ra{
      width:100%;
      line-height:80px;
      padding-left:150px;
    }
  }
  .u-btn{
    display: block;
    margin: 0 auto;
    width: 100%;
    border-radius: 15px;
    border: none;
    background-color: #F57F17;
    font-size: 32px;
    text-align: center;
    color: #ffffff;
    line-height: 80px;
  }
}
.save-userinfo.on{
  left: 50%;
}
</style>

